import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "../../../context/AppConfigProviderContext.tsx";
import FieldValuePair from "../FieldValuePair.tsx";

export const Effect = ({ effect }: { effect?: number }) => {
  const { locale } = useAppConfig();
  const { i18n } = useLingui();

  if (effect == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.engine.effect",
    message: "Engine effect",
    comment: "Field for 'engine effect' in ad specification",
  });

  const value = i18n.t({
    id: "itemPageLayout.common.engine.effect.postfix",
    message: "{effect} Hp",
    comment: "Engine effect incl. postfix",
    values: {
      effect: formatNumber(effect, locale, 0),
    },
  });
  return <FieldValuePair field={field} value={value} />;
};
